/**
 * InfoHint — popover informativo «i» para campos no obvios (AUTONOMY · Layer 2).
 *
 * Uso: junto a la etiqueta de un campo cuyo efecto no es evidente (escala de
 * calificación, waitlist, verificación de pagos, doble moneda…). El contenido
 * es prosa i18n-izada — no un tooltip truncado.
 */
import type { JSX } from "solid-js";
import { Info } from "lucide-solid";
import { msg } from "@lingui/core/macro";

import { useI18n } from "@/providers/i18n-provider";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function InfoHint(props: { children: JSX.Element; label?: string }) {
  const { t } = useI18n();
  return (
    <Popover>
      <PopoverTrigger
        aria-label={props.label ?? t(msg`More information`)}
        class="inline-flex h-4 w-4 items-center justify-center rounded-full align-middle text-muted-foreground/70 transition-colors hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
      >
        <Info class="h-3.5 w-3.5" />
      </PopoverTrigger>
      <PopoverContent class="text-xs leading-relaxed text-muted-foreground">
        {props.children}
      </PopoverContent>
    </Popover>
  );
}
